import React from 'react';
import Rastreadores from '../components/templates/Rastreadores/Rastreadores';

function RastreadoresPage() {
  return <Rastreadores />;
}

export const config = {
  amp: false,
};

export default RastreadoresPage;
